import { createRoot } from 'react-dom/client';
import ReactDOM from "react-dom";
import React, {Fragment} from "react";
import { Parser as HtmlToReactParser, ProcessNodeDefinitions } from "html-to-react";

import {CopyToClipboardInput, CopyToClipboardWrapper} from '../components/copyToClipboard';


function parseHtml(html) {
  const processNodeDefinitions = new ProcessNodeDefinitions(React);
  const processingInstructions = [
    {
      shouldProcessNode: node => {
        return node.attribs && 'data-copy-to-clipboard' in node.attribs;
      },
      processNode: node => {
        const copyValue = node.attribs.value;
        return (
          <CopyToClipboardInput copyValue={ copyValue } />
        );
      }
    },
    {
      shouldProcessNode: () => true,
      processNode: processNodeDefinitions.processDefaultNode
    }
  ];
  const htmlToReactParser = new HtmlToReactParser();
  return htmlToReactParser.parseWithInstructions(html, () => true, processingInstructions);
}

function init() {
  document.querySelectorAll('[data-copy-to-clipboard-wrapper]').forEach(el => {
    const parsedHtml = parseHtml(el.innerHTML);
    const copiedHtml = parseHtml(el.getAttribute('data-copied-content'));
    const copyValue = el.getAttribute('data-copy-value');
    const root = createRoot(el);
    root.render(
      <CopyToClipboardWrapper
        copyValue={ copyValue }
        copiedHtml={ copiedHtml }
      >
        { parsedHtml }
      </CopyToClipboardWrapper>
    );
  });
}

export default { init };
